import { ReactElement } from 'react';
import Carousel from 'components/UI/Carousel';
import { IFragmentCtaFields } from 'types/contentful';
import { Document } from '@contentful/rich-text-types';
import { ProductVariantFieldsWithBrand } from 'components';

interface CarouselProps {
  products: ProductVariantFieldsWithBrand[];
  title: string;
  description?: Document | undefined;
  cta?: IFragmentCtaFields | undefined;
  backgroundColor?: 'white' | 'muted' | 'primary' | undefined;
  fitProductImages?: boolean;
  hideProductItemsTitle?: boolean;
}

export default function ProductCarousel({
  title,
  description,
  products,
  cta,
  backgroundColor,
  fitProductImages = false,
  hideProductItemsTitle = false,
}: CarouselProps): ReactElement {
  const aspectRatio = 'landscape';
  const backgroundClass =
    backgroundColor && backgroundColor == 'muted' ? `bg-${backgroundColor}` : '';
  const imageBackgroundClass = fitProductImages ? 'bg-contain bg-no-repeat' : 'bg-cover';

  const carouselItems = products
    .map((item, index) => {
      if (!item.primaryFrameImage) {
        return null;
      }

      return (
        <a href={item.url} key={`${item.sku}-${index}`}>
          <div className="text-center">
            <div
              style={{
                backgroundImage: `url('${item.primaryFrameImage.fields.file.url}')`,
                aspectRatio,
              }}
              className={`aspect-ratio-${aspectRatio} ${imageBackgroundClass} bg-center`}
            ></div>
            {!hideProductItemsTitle && <span className="text-lg">{item.brand ?? item.sku}</span>}
          </div>
        </a>
      );
    })
    .filter((item): item is ReactElement => item !== null);

  return (
    <Carousel
      title={title}
      description={description}
      items={carouselItems}
      cta={cta}
      style=""
      className={`carousel-products ecp-my pb-10 md:pb-20 px-site-component ${backgroundClass}`}
      innerClassName={`${backgroundColor == 'muted' ? 'py-10' : ''}`}
      contentClassName="w-full"
      titleClassName="no-padding-x"
      sliderClassName="w-product-carousel mx-auto"
    />
  );
}
